import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { locationKind } from "../../location/location-kind.const";

@Component({
  selector: "app-location-icon",
  templateUrl: "./location-icon.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./location-icon.component.scss"],
})
export class LocationIconComponent {
  public readonly kind = input(undefined);
  // A location group has no kind of its own — it stands for a set of locations.
  public readonly locationGroup = input(false);
  public locationKind = locationKind;
  constructor() {}
}
